/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.Meeting = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The Meeting model module.
   * @module model/Meeting
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>Meeting</code>.
   * @alias module:model/Meeting
   * @class
   */
  var exports = function() {
    var _this = this;






















  };

  /**
   * Constructs a <code>Meeting</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Meeting} obj Optional instance to populate.
   * @return {module:model/Meeting} The populated <code>Meeting</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TemplateID')) {
        obj['TemplateID'] = ApiClient.convertToType(data['TemplateID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('OrganizerID')) {
        obj['OrganizerID'] = ApiClient.convertToType(data['OrganizerID'], 'Integer');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('FunctionID')) {
        obj['FunctionID'] = ApiClient.convertToType(data['FunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('InvitesSendDate')) {
        obj['InvitesSendDate'] = ApiClient.convertToType(data['InvitesSendDate'], 'Date');
      }
      if (data.hasOwnProperty('InvitesSent')) {
        obj['InvitesSent'] = ApiClient.convertToType(data['InvitesSent'], 'Boolean');
      }
      if (data.hasOwnProperty('BlobStorageURI')) {
        obj['BlobStorageURI'] = ApiClient.convertToType(data['BlobStorageURI'], 'String');
      }
      if (data.hasOwnProperty('ArchivedBy')) {
        obj['ArchivedBy'] = ApiClient.convertToType(data['ArchivedBy'], 'Integer');
      }
      if (data.hasOwnProperty('ArchivedDate')) {
        obj['ArchivedDate'] = ApiClient.convertToType(data['ArchivedDate'], 'Date');
      }
      if (data.hasOwnProperty('CustomMinutesBlobStorageURI')) {
        obj['CustomMinutesBlobStorageURI'] = ApiClient.convertToType(data['CustomMinutesBlobStorageURI'], 'String');
      }
      if (data.hasOwnProperty('GenerateArchiveStartDate')) {
        obj['GenerateArchiveStartDate'] = ApiClient.convertToType(data['GenerateArchiveStartDate'], 'Date');
      }
      if (data.hasOwnProperty('MeetingMinutesResponsibleUserID')) {
        obj['MeetingMinutesResponsibleUserID'] = ApiClient.convertToType(data['MeetingMinutesResponsibleUserID'], 'Integer');
      }
      if (data.hasOwnProperty('StartFromLastFollowUps')) {
        obj['StartFromLastFollowUps'] = ApiClient.convertToType(data['StartFromLastFollowUps'], 'Boolean');
      }
      if (data.hasOwnProperty('FollowUpsSectionDuration')) {
        obj['FollowUpsSectionDuration'] = ApiClient.convertToType(data['FollowUpsSectionDuration'], 'Integer');
      }
      if (data.hasOwnProperty('ReminderSendDate')) {
        obj['ReminderSendDate'] = ApiClient.convertToType(data['ReminderSendDate'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} TemplateID
   */
  exports.prototype['TemplateID'] = undefined;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatedBy
   * @default 0
   */
  exports.prototype['CreatedBy'] = 0;
  /**
   * @member {Integer} OrganizerID
   * @default 0
   */
  exports.prototype['OrganizerID'] = 0;
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;
  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {Integer} FunctionID
   * @default 0
   */
  exports.prototype['FunctionID'] = 0;
  /**
   * @member {Date} InvitesSendDate
   */
  exports.prototype['InvitesSendDate'] = undefined;
  /**
   * @member {Boolean} InvitesSent
   * @default false
   */
  exports.prototype['InvitesSent'] = false;
  /**
   * @member {String} BlobStorageURI
   * @default ''
   */
  exports.prototype['BlobStorageURI'] = '';
  /**
   * @member {Integer} ArchivedBy
   */
  exports.prototype['ArchivedBy'] = undefined;
  /**
   * @member {Date} ArchivedDate
   */
  exports.prototype['ArchivedDate'] = undefined;
  /**
   * @member {String} CustomMinutesBlobStorageURI
   * @default ''
   */
  exports.prototype['CustomMinutesBlobStorageURI'] = '';
  /**
   * @member {Date} GenerateArchiveStartDate
   */
  exports.prototype['GenerateArchiveStartDate'] = undefined;
  /**
   * @member {Integer} MeetingMinutesResponsibleUserID
   */
  exports.prototype['MeetingMinutesResponsibleUserID'] = undefined;
  /**
   * @member {Boolean} StartFromLastFollowUps
   * @default false
   */
  exports.prototype['StartFromLastFollowUps'] = false;
  /**
   * @member {Integer} FollowUpsSectionDuration
   * @default 0
   */
  exports.prototype['FollowUpsSectionDuration'] = 0;
  /**
   * @member {Date} ReminderSendDate
   */
  exports.prototype['ReminderSendDate'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


